<template>
  <div class='custom-select' v-click-outside='close'>
    <input type='hidden' :name='name' v-for='selection in Object.values(selections)' :key='selection.id' :value='selection.id' />

    <div @click.prevent='open'>
      <input type='text' v-model='q' :disabled='disabled'>

      <div v-if='Object.keys(selections).length > 0' class='selected-option'>
        <ul>
          <li v-for='selection in Object.values(selections)' :key='selection.id'>
            <span @click='deselect(selection)'>x</span>
            {{ template(selection) }}
          </li>
        </ul>
        <a href="#" @click.prevent="clear" class="remove-all">
          {{ $t('relatico_multiselect.clear') }}
        </a>
      </div>
    </div>

    <ul v-show='opened' class='options-list'>
      <li @click.prevent='select(o)' v-for='o in filteredOptions' :key='o.id'>
        {{ template(o) }}
      </li>

      <li v-show='filteredOptions.length == 0'>
        {{ $t('shared.no_results') }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    props: {
      options: {
        type: Array,
        required: true,
        validator: (opts) => opts.reduce((s, o) => s && o.id, true)
      },
      name: {
        type: String
      },
      value: {
        type: Array,
        default: () => ([])
      },
      template: {
        type: Function,
        default: (x) => x.name
      },
      disabled: {
        type: Boolean,
        default: () => (false)
      }
    },
    data() {
      return {
        q: '',
        opened: false
      }
    },
    computed: {
      query() {
        return this.q.toLowerCase()
      },
      selections() {
        const res = {}

        this.$props.value.forEach(v => res[v.id] = v)

        return res
      },
      filteredOptions() {
        const isQueryInOpt = (opt) => {
          return this.q == '' || this.template(opt).toLowerCase().indexOf(this.query) >= 0
        }

        return this.options.filter(opt => isQueryInOpt(opt) && !this.selections[opt.id])
      }
    },
    methods: {
      open() {
        if (!this.disabled)
          this.opened = true
      },
      close() {
        this.opened = false
      },
      select(option) {
        const newSelection = Object.assign({}, this.selections, { [option.id]: option })
        this.$emit('input', Object.values(newSelection))
      },
      deselect(option) {
        const newSelection = Object.assign({}, this.selections)
        this.$delete(newSelection, option.id)
        this.$emit('input', Object.values(newSelection))
      },
      clear() {
        this.$emit('input', [])
      }
    }
  }
</script>

<style lang='sass' scoped>
  @import "../../styles/select"
</style>
